<template>
  <div class="dashboard-carousel-card">
    <div class="dashboard-carousel-card-wrapper">
      <div class="dashboard-carousel-card-image">
        <picture
          class="image-wrapper"
          v-lazyload="{
            src: card.imgSrc,
            set: [
              { width: '480', height: '240', breakpoint: 'xs' },
              { width: '800', height: '360', breakpoint: 'md' },
            ],
            fit: 'crop',
            align: 'center',
          }"
        >
          <img
            class="image"
            src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
            v-bind:alt="card.imgAlt"
          />
        </picture>
      </div>
      <div class="dashboard-carousel-card-content">
        <span class="dashboard-carousel-card-title">{{ card.title }}</span>
        <span class="dashboard-carousel-card-description">{{
          card.description
        }}</span>
        <div class="dashboard-carousel-card-ctas">
          <a :href="ctaHref" :target="card.ctaTarget" class="dashboard-carousel-card-ctas-link">
            {{ card.ctaLabel }}
          </a>
          <a
            v-if="showDismissBtn"
            @click="handleDismissClick()"
            class="button dashboard-carousel-card-ctas-dismiss"
            >{{tc('auth.dismiss')}}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    cardIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState("global", ["lang"]),
    ...mapGetters('i18n', ['tc']),
    showDismissBtn() {
      return this.card.isSensitiveDataTerms || this.card.isMarketingOptIn;
    },
    ctaHref() {
      if(this.card.isSensitiveDataTerms){
        return `${this.card.ctaUrl}?sensitiveData=true`

      } else if(this.card.isMarketingOptIn) {
        return `${this.card.ctaUrl}?marketingOptIn=true#communications`

      } else {
        return this.card.ctaUrl
      }
    }
  },
  methods: {
    handleDismissClick() {
      this.$emit("dismissClicked", {card: this.card, cardIndex: this.cardIndex});
    }
  },
};
</script>
